import React, { FC } from "react";
import { Image } from "../image";
import type { CentralBanksOvercomeBlindSpotsProps } from "@/types";
import { TextCols } from "../text-cols";

export const CentraBanksOvercomeBlindSpots: FC<
  CentralBanksOvercomeBlindSpotsProps
> = ({ content, cover }) => {
  return (
    <section className="centralBanksOvercomeBlindSpots">
      <div className="wrapper">
        <TextCols content={content} maxTitleWidth={626} />
      </div>
      <div className="wrapper wrapper_lg">
        {cover.file?.url && (
          <Image
            className="centralBanksOvercomeBlindSpots--cover"
            src={cover as any}
            alt={cover.title}
            animateInView
          />
        )}
      </div>
    </section>
  );
};
